import PropTypes from 'prop-types';
import { Component } from 'react';
import Translations from '../../utils/Translations';
import { VXPay } from '../../utils/VXPay';
import ReloadHelper from '../../utils/ReloadHelper';

class NavbarNotificationsDropdown extends Component {
	static getClassNameByType(type) {
		let classname = '';
		switch (type) {
			case 1: // Email address verification needed
			case 8: // AVS recommended
			case 10: // balance low
			case 11: // Messages importing
			case 16: // E-mail bounce
			case 27: // avs rejected
			case 28: // profile picture rejected
				classname = '-icon-round-warning-line h-color-highlight';
				break;
			case 4: // Textchat info
			case 5: // Actor pinned
			case 13: // Album pinned
			case 14: // Picture pinned
			case 15: // Sedcards pinned
			case 6: // Private Shop Video bought
			case 7: // Private Shop Gallery bought
			case 17: // remaining limit
			case 20: // bonus code info
			case 22: // guest profile not completed
			case 26: // avs pending
			case 32: // feed released
				classname = '-icon-round-info-line h-color-special';
				break;
			case 25: // ticket bought
				classname = '-icon-videotake-full h-color-success';
				break;
			case 35:
				//reply
				classname = '-icon-chat-text-line h-color-special';
				break;
			case 36:
				//mention
				classname = '-icon-chatlist-line h-color-special';
				break;
			case 2: // Email address verified
			case 9: // AVS completed
			case 12: // Messages imported
			case 18: // limit changed
			case 19: // payment success
			case 21: // password changed
			default:
				classname = '-icon-round-success-line h-color-success';
				break;
		}

		return classname;
	}

	/**
	 * @see EnumNotificationTarget
	 */
	static proceedToTarget(e, target) {
		switch (target.type) {
			case 'link':
				ReloadHelper.reloadWithPjax(target.link, e);
				break;

			case 'vxpay':
				switch (target.mode) {
					case 'settings':
						VXPay.openSettings();
						break;

					case 'avs':
						VXPay.openAVS();
						break;

					case 'paytour':
						VXPay.openPaytour();
						break;
					default:
				}
				break;
			default:
		}
	}

	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handleCloseClick = this.handleCloseClick.bind(this);
		this.markAllAsReadClickHandler = this.markAllAsReadClickHandler.bind(this);
	}

	handleClick(e, id, target, unread) {
		// mark notification as read
		if (unread) {
			this.props.markNotificationAsRead(id);
			NavbarNotificationsDropdown.proceedToTarget(e, target);
		} else {
			NavbarNotificationsDropdown.proceedToTarget(e, target);
		}
	}

	handleCloseClick(e, id) {
		this.props.markNotificationAsRead(id);
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		if (e.preventDefault) {
			e.preventDefault();
		}
		return false;
	}

	markAllAsReadClickHandler(event) {
		if (typeof event === 'object' && event.cancelable) {
			event.preventDefault();
		}
		this.props.markAllNotificationsAsRead();
	}

	render() {
		// create list
		const maxVisibleItems = 10;
		const list = this.props.notifications
			.filter((item) => item.unread === true)
			.slice(0, maxVisibleItems)
			.map(
				function (item) {
					const iconClassName = 'icon ' + NavbarNotificationsDropdown.getClassNameByType(item.type);

					const statusCreated = <span>{item.createdFormatted}</span>;

					const liClassName = 'dropdown-menu__item h-cursor-pointer';

					let textSpan;
					if (item.text) {
						textSpan = <span className="message-text">{item.text}</span>;
					}

					const onClick = (e) => this.handleClick(e, item.id, item.target, item.unread);
					const onCloseClick = (e) => this.handleCloseClick(e, item.id);

					return (
						<li className="dropdown-menu__item__table -padding-high__item" key={'item-' + item.id}>
							<a className={liClassName} onClick={onClick}>
								<i className="icon -icon-close-full dropdown-menu__item__close" onClick={onCloseClick} />
								<span className="dropdown-menu__item__cell -width-auto -padding-top-tiny">
									<i className={iconClassName} />
								</span>
								<span className="dropdown-menu__item__cell -vertical-top">
									<span className="h-disp-block">
										{item.subject} <span className="message-period-text -font-small">{statusCreated}</span>
									</span>
									{textSpan}
								</span>
							</a>
						</li>
					);
				}.bind(this),
			);

		if (list.length > 0) {
			return (
				<ul className="dropdown-menu -width-wide -with-shadow h-list--unstyled-block">
					{list}
					<li className="dropdown-menu__item__table -width-middle" key="actionbar">
						<a onClick={this.markAllAsReadClickHandler} className="dropdown-menu__item -show-more h-cursor-pointer">
							<span className="dropdown-menu__item__cell h-text-align-center h-text-underline">
								{Translations.get('NavbarNotificationMarkAllAsRead')}
							</span>
						</a>
					</li>
				</ul>
			);
		} else {
			return (
				<ul className="dropdown-menu -width-middle h-list--unstyled-block">
					<li className="dropdown-menu__item__table" key="actionbar">
						<a className="dropdown-menu__item">
							<span className="dropdown-menu__item__cell">
								<span className="icon">
									<i className="fa fa-fw fa-info-circle"></i>
								</span>
							</span>
							<span className="dropdown-menu__item__cell">
								<span className="text">{Translations.get('NavbarNotificationNoEntriesText')}</span>
							</span>
						</a>
					</li>
				</ul>
			);
		}
	}
}

NavbarNotificationsDropdown.propTypes = {
	notifications: PropTypes.array.isRequired,
	markNotificationAsRead: PropTypes.func.isRequired,
	markAllNotificationsAsRead: PropTypes.func.isRequired,
};

export default NavbarNotificationsDropdown;
